import {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import PageLayout from '../../Layout/PageLayout.jsx'

import actions from '../actions.js'

class NotFound extends Component {
  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: ''
  }

  back = () => {
    if(this.props.route.redirect) {
      this.props.history.goBack()
    }
    this.props.history.goBack()
  }

  render() {
    return (
      <PageLayout>
        <h2 className="text-center">
          Erreur 404 - Impossible d'accéder à ce contenu.
        </h2>
        <p className="text-center">
          <button className="btn btn-primary" onClick={this.back}>Retour</button>
        </p>
      </PageLayout>
    )
  }
}

export default connect(
  (state) => ({}),
  (dispatch) => bindActionCreators({...actions}, dispatch)
)(NotFound)